import { render, staticRenderFns } from "./CoreButton.vue?vue&type=template&id=d627408a&lang=pug&"
import script from "./CoreButton.vue?vue&type=script&lang=js&"
export * from "./CoreButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports